var render = function render(){var _vm=this,_c=_vm._self._c;return _c('app',{attrs:{"tabbar":""}},[_c('scroll-list-m',{ref:"list",scopedSlots:_vm._u([{key:"default",fn:function({data}){return [_c('div',{staticClass:"message",class:{'z-new': data.state == 1}},[_c('span',[_vm._v(_vm._s(data.create_date))]),_c('div',[_c('h1',[_vm._v(_vm._s(data.title))]),_c('p',[_vm._v(_vm._s(data.content))])])])]}}])})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }